import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from 'src/environments/environment';
import { ConfirmDialogService } from './confirm-dialog/confirm-dialog.service';
import { Router } from '@angular/router';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class IdleService {

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;



  constructor(private idle: Idle,
    private keepalive: Keepalive,
    private confirmDialogService: ConfirmDialogService,
    private router: Router,
    private appService: AppService

  ) {

    idle.setIdle(parseInt(environment.IDLE_TIME_OUT.toString()));
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(parseInt(environment.SESSION_TIME_OUT.toString()));
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.router.navigate(['/']);
      this.appService.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'Need More Time?';
      this.confirmDialogService.confirmThis(
        'Session',
        'Your session is about to expire. Select YES to remain in your session',
        () => {
          this.idleState = 'No longer idle, continue session';
          this.reset();
        },
        () => {
          this.idleState = 'Timed out!';
          this.timedOut = true;
          this.router.navigate(['/']);
          this.appService.logout();
        }
      );

    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });
  }

  initIdle() {    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}
